<template>
  <div class="common-container">
    <div class="classify-product">
      <div class="bg">
        <el-image :src="require('@/assets/product/classify/bg.png')"></el-image>
        <div class="name">{{ name }}</div>
      </div>
      <div class="main">
        <div class="m-left">
          <classify :name="name" :classify-id="classifyId" :t-classify-id.sync="tClassifyId"/>
        </div>
        <div class="m-right">
          <el-empty v-if="resultData.list.length < 1" description="暂无产品"></el-empty>
          <div class="product-list" v-else>
            <div class="pl-item" v-for="(v,i) in resultData.list" :key="i"
                 @click="$router.push(`/product/detail?productId=${v.productId}&name=${name}&classifyId=${classifyId}`)">
              <el-image :src="v.image"></el-image>
              <div class="name">{{ v.name }}</div>
            </div>
          </div>
          <el-pagination
              v-if="resultData.list.length > 0"
              @current-change="currentPageChange"
              :page-size="12"
              layout="total, prev, pager, next, jumper"
              :total="resultData.count">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Classify from '../components/Classify.vue'

export default {
  name: "ProductClassify",
  components: {
    Classify
  },
  data() {
    return {
      name: '',
      classifyId: null,
      tClassifyId: null,
      resultData: {
        list: [],
        count: 0
      },
      page: 1
    }
  },
  watch: {
    '$route.query': {
      immediate: true,
      deep: true,
      handler({name, classifyId}) {
        this.name = name
        this.classifyId = classifyId
        this.resultData = {
          list: [],
          count: 0
        }
        this.page = 1
      }
    },
    tClassifyId: {
      handler(val) {
        this.resultData = {
          list: [],
          count: 0
        }
        this.page = 1
        this.getDataList(val)
      }
    }
  },
  methods: {
    /**
     * 获取
     */
    getDataList(classifyId) {
      const params = {
        classifyId,
        page: this.page
      }
      this.$request.get('/Product/pageList', {
        params
      }).then(res => {
        if (res.code === 0) {
          this.resultData = res.data
        }
      })
    },
    /**
     * 翻页
     **/
    currentPageChange(current) {
      this.page = current
      this.getDataList(this.tClassifyId)
    }
  }
}
</script>

<style scoped lang="scss">
.classify-product {
  width: 1200px;
  padding: 30px 0 60px 0;
  display: flex;
  flex-direction: column;
  align-items: center;

  .bg {
    width: 100%;
    height: 136px;
    position: relative;
    line-height: 136px;

    .el-image {
      position: absolute;
      left: 0;
      top: 0;
    }

    .name {
      position: absolute;
      width: 100%;
      text-align: center;
      color: #FFFFFF;
      font-size: 38px;
      font-weight: bold;
    }
  }

  .main {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    margin-top: 25px;

    .m-right {
      width: 940px;

      .el-empty {
        margin-top: 30px;
      }

      .product-list {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 20px;

        .pl-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 220px;
          height: 262px;
          background-color: #FFFFFF;
          border-radius: 8px;
          overflow: hidden;
          cursor: pointer;
          transition: all .3s;

          &:hover {
            box-shadow: 0 1px 7px rgba(136, 147, 169, 0.24);
            transform: scale(1.03);
          }

          .el-image {
            width: 100%;
            height: 208px;
          }

          .name {
            text-align: center;
            width: 100%;
            padding: 0 10px;
            height: 54px;
            line-height: 54px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            color: #000000;
            font-weight: bold;
            font-size: 14px;
          }
        }
      }

      .el-pagination {
        text-align: center;
        margin-top: 30px;

        ::v-deep {
          button, .el-pager li, .el-input__inner {
            background-color: transparent !important;
          }
        }
      }
    }
  }
}
</style>